import { catalog } from "../i18n.js";

/** A bot's live screen (components/Computer.tsx): the card in the details pane and the full pane. */
export const COMPUTER = catalog(
  {
    noScreenServed: "this host is not serving a screen",
    refused: (reason: string) => `the screen refused the connection: ${reason}`,
    unknownReason: "unknown reason",
    closed: "the connection closed",
    dropped: "the connection dropped",
    viewerFailed: (error: string) => `the screen viewer did not load: ${error}`,

    noScreenYet: (name: string) => `${name} has no screen of its own yet`,
    booting: "Booting up the computer",
    cantReach: (name: string) => `Can't reach ${name}'s screen`,
    idleNote: "It takes one when it first uses the desktop, and keeps it afterwards.",
    retry: "Retry",

    screenOf: (name: string) => `${name}'s screen`,
    openLarge: "Open the screen large; take it over from there",
    open: "Open",

    computerOf: (name: string) => `${name}'s computer`,
    inUse: ", in use",
    stopDriving: "Stop sending your mouse and keyboard to the computer",
    startDriving: "Send your mouse and keyboard to the computer",
    handBack: "Hand back",
    takeOver: "Take over",
    exitFullscreen: "Exit fullscreen",
    fullscreen: "Fullscreen",
    close: "Close",

    needsAttention: "Needs your attention",
    skipStepTitle: "Hand the screen back without doing the step; the bot carries on without it",
    skipStep: "Skip this step",
    doneContinue: "I'm done, continue",

    screens: "Screens",
    screenWorking: (title: string, waiting: boolean) => `${title}: working${waiting ? ", and waiting on you" : ""}`,
    screenIdle: (title: string) => `${title}: idle`,
    stepHint: "← → to step",

    footWaiting: (name: string) => `${name} is waiting on you. The screen is yours until you answer.`,
    footDriving: "Your mouse and keyboard go to the computer. Hand it back when you are done.",
    footWorking: (name: string) => `${name} is working; watch, or take over.`,
    footWatching: "Watching. Take over to use the computer yourself.",
  },
  {
    noScreenServed: "host ini tidak menyediakan layar",
    refused: (reason: string) => `layar menolak koneksi: ${reason}`,
    unknownReason: "alasan tidak diketahui",
    closed: "koneksi ditutup",
    dropped: "koneksi terputus",
    viewerFailed: (error: string) => `penampil layar gagal dimuat: ${error}`,

    noScreenYet: (name: string) => `${name} belum punya layar sendiri`,
    booting: "Menyalakan komputer",
    cantReach: (name: string) => `Tidak bisa terhubung ke layar ${name}`,
    idleNote: "Layarnya dibuat saat pertama kali memakai desktop, dan tetap miliknya setelah itu.",
    retry: "Coba lagi",

    screenOf: (name: string) => `Layar ${name}`,
    openLarge: "Buka layar dalam ukuran besar; ambil alih dari sana",
    open: "Buka",

    computerOf: (name: string) => `Komputer ${name}`,
    inUse: ", sedang dipakai",
    stopDriving: "Berhenti mengendalikan komputer dengan mouse dan keyboard kamu",
    startDriving: "Kendalikan komputer dengan mouse dan keyboard kamu",
    handBack: "Kembalikan",
    takeOver: "Ambil alih",
    exitFullscreen: "Keluar layar penuh",
    fullscreen: "Layar penuh",
    close: "Tutup",

    needsAttention: "Butuh perhatianmu",
    skipStepTitle: "Kembalikan layar tanpa mengerjakan langkah ini; bot lanjut tanpanya",
    skipStep: "Lewati langkah ini",
    doneContinue: "Sudah, lanjutkan",

    screens: "Layar",
    screenWorking: (title: string, waiting: boolean) => `${title}: bekerja${waiting ? ", dan menunggu kamu" : ""}`,
    screenIdle: (title: string) => `${title}: tidak aktif`,
    stepHint: "← → untuk pindah",

    footWaiting: (name: string) => `${name} menunggu kamu. Layarnya milikmu sampai kamu menjawab.`,
    footDriving: "Mouse dan keyboard kamu mengendalikan komputer. Kembalikan kalau sudah selesai.",
    footWorking: (name: string) => `${name} sedang bekerja; tonton, atau ambil alih.`,
    footWatching: "Menonton. Ambil alih untuk memakai komputernya sendiri.",
  },
);
